import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'
import { Link, useParams } from 'react-router-dom';
import paymentsService from '../../services/PaymentServices';
import Loading from '../../components/feedback/Loading';
import PaymentInfo from './PaymentInfo';
import DeliverySecurity from './DeliverySecurity';

function UserPaymentConfirmPage() {
    const { txRef } = useParams();
    const [payment, setPayment] = useState()
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (txRef) {
            getPayment(txRef)
        }
    }, [txRef])



    function updatePage() {
        paymentsService.reconfirmPayment(txRef).then(
            res => {
                setPayment(res.data)
                setLoading(false)
            },
            err => {
                setError(err)
                setLoading(false)
            }
        )
    }

    const getPayment = async (ref) => {
        setError()
        paymentsService.reconfirmPayment(ref).then(
            res => {
                setPayment(res.data)
                setLoading(false)
            },
            err => {
                setError(err)
                setLoading(false)
            }
        )
    }

    return (
        <div>
            <Helmet>
                <title>Order Overview - {utils.siteName}</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <div className="flex items-center justify-center min-h-[50vh] w-full py-4">
                <div className="bg-white dark:bg-slate-900 p-8 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg w-12/12 md:w-8/12 lg:w-5/12">
                    <div className="space-y-3">
                        <h1 className="text-2xl text-primary font-bold">Order Overview</h1>
                        <p className="text-gray-600">Track your order status and prepare for delivery.</p>

                        {loading ? (
                            <div className="flex justify-center py-6">
                                <Loading />
                            </div>
                        ) : error ? (
                            <div className="py-4 space-y-4">
                                <div className="flex justify-center">
                                    <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl shadow-primary/10">

                                        <div className="absolute top-[-20%] right-[-20%] w-64 h-64 bg-primary/20 rounded-full blur-3xl"></div>
                                        <div className="absolute bottom-[-20%] left-[-20%] w-64 h-64 bg-accent-red/20 rounded-full blur-3xl"></div>
                                        <div className="relative not-found-bg z-5 w-full h-full bg-center bg-cover bg-no-repeat" data-alt="3D playful illustration of a floating cardboard box in space with orange accent lighting">
                                            <div className="absolute inset-0 bg-gradient-to-t from-background-light/80 to-transparent dark:from-background-dark/80"></div>
                                        </div>
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <h1 className="text-[120px] md:text-[160px] font-extrabold text-white mix-blend-overlay opacity-90 leading-none select-none">404</h1>
                                        </div>
                                    </div>
                                </div>
                                <p className="text-gray-700 dark:text-gray-300 max-w-2xl mx-auto">
                                    If you're having trouble viewing your order or believe this is an error, please contact our customer care team.
                                    To help us assist you faster, include the following details in your message:
                                </p>

                                <ul className="text-gray-600 dark:text-gray-400 list-disc list-inside max-w-md mx-auto space-y-0.5">
                                    <li>The email address used during checkout</li>
                                    <li>Your full name</li>
                                    <li>Order reference (if available)</li>
                                    <li>Date of purchase</li>
                                </ul>

                                <p className="">
                                    Reach us at{' '}
                                    <a
                                        href="mailto:hello@koova.co.ke?subject=Order%20Support&body=Email%20used%20during%20checkout%3A%0AFull%20name%3A%0AOrder%20number%20(if%20known)%3A%0APurchase%20date%3A"
                                        className="text-secondary font-medium hover:underline"
                                    >
                                        hello@koova.co.ke
                                    </a>
                                </p>

                                <div className="divider"></div>

                                <div className="flex justify-center pt-5">
                                    <div className="flex flex-col sm:flex-row gap-4 w-full justify-center">
                                        <Link className="flex flex-1 cursor-pointer items-center justify-center rounded-xl h-12 px-6 bg-primary hover:bg-orange-600 text-white text-base font-bold leading-normal tracking-[0.015em] transition-all shadow-lg shadow-primary/25 transform hover:-translate-y-0.5" to="/">
                                            Return to Homepage
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        ) : (
                            <div className="py-4 space-y-7">
                                {payment && (
                                    <>
                                        <PaymentInfo
                                            updatePage={updatePage}
                                            payment={payment} />
                                        <DeliverySecurity payment={payment} />
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default UserPaymentConfirmPage